import React, { useEffect, useRef } from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useLocation,
} from 'react-router-dom';

interface LinkProps extends RouterLinkProps {
  preload?: () => void;
}

export const Link: React.FC<LinkProps> = ({
  to,
  preload,
  children,
  ...rest
}) => {
  const linkRef = useRef<HTMLAnchorElement | null>(null);
  const observer = useRef<IntersectionObserver | null>(null);

  const location = useLocation();

  useEffect(() => {
    if (!('IntersectionObserver' in window)) {
      console.warn('IntersectionObserver não é suportado no navegador.');
      return;
    }

    if (!preload) return;

    const ref = linkRef.current;

    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            preload();
            observer.current?.disconnect();
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.1 },
    );

    if (ref) {
      observer.current.observe(ref);
    }

    function handleMouseEnter() {
      if (preload) {
        preload();
      }
    }

    if (ref) {
      ref.addEventListener('mouseenter', handleMouseEnter);
    }

    return () => {
      observer.current?.disconnect();

      if (ref) {
        ref.removeEventListener('mouseenter', handleMouseEnter);
      }
    };
  }, [preload]);

  return (
    <RouterLink
      to={to}
      ref={linkRef}
      state={{ lastPathname: rest.replace ? to : location.pathname }}
      {...rest}
    >
      {children}
    </RouterLink>
  );
};
